module.exports = __webpack_public_path__ + "img/KPIs.5315f8af.jpg";